/**
 * Created by dinesh on 13/6/17.
 */
import {Component} from '@angular/core';
import {AngularTokenService} from '@lakshvairav/angular-token';
import {Router} from '@angular/router';

@Component({
  selector: 'data-output',
  templateUrl: 'data-output.component.html'
})
export class DataOutputComponent {

  constructor(private router: Router, private _tokenService: AngularTokenService) {
  }
}
